import React from 'react';
import './SingleCalendar.css';
import { Calendar } from 'primereact/calendar';
import Cookies from 'js-cookie';
import { addLocale, locale } from 'primereact/api';
import {getUtcDateWithLocalMidnight} from "../../utils/GeneralFunctions"

addLocale('ar', {
  firstDayOfWeek: 0, // Sunday
  dayNames: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
  dayNamesShort: ['أحد', 'اثن', 'ثلا', 'أرب', 'خمي', 'جمع', 'سبت'],
  dayNamesMin: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
  monthNames: [
    'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
    'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
  ],
  monthNamesShort: [
    'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
    'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
  ],
//   monthNamesShort: [
//     'ينا', 'فبر', 'مار', 'أبر', 'ماي', 'يون',
//     'يول', 'أغس', 'سبت', 'أكت', 'نوف', 'ديس'
//   ],
  today: 'اليوم',
  clear: 'مسح',
  now: 'الاَن',
  dateFormat: 'dd/mm/yy',
  weekHeader: 'أسبوع'
});


const SingleCalendar = ({
  placeholder,
  value,
  onChange,
  dateRef,
  min,
  max,
  onClearButtonClick,
  showTime = true,
  disabled = false,
  onHide,
  viewDate
}) => {
  const Lang = Cookies.get('preferred_language') || 'en';


  // Set locale dynamically before rendering Calendar
  locale(Lang === 'ar' ? 'ar' : 'en');

  // Normalize min/max dates
  let minDate = null;
  let maxDate = null;


  if (min instanceof Date && !isNaN(min)) {
    minDate = getUtcDateWithLocalMidnight(min);
  }

  if (max instanceof Date && !isNaN(max)) {
    maxDate = getUtcDateWithLocalMidnight(max);
  }

  return (
    <div ref={dateRef}>
      <Calendar
        locale={Lang === 'ar' ? 'ar' : 'en'}
        dir={Lang === 'ar' ? 'rtl' : 'ltr'}
        minDate={minDate}
        maxDate={maxDate}
        showTime={showTime}
        value={value}
        onChange={onChange}
        className="single-calendar"
        placeholder={placeholder}
        disabled={disabled}
        showButtonBar
        onClearButtonClick={onClearButtonClick}
        onHide={onHide}
        viewDate={viewDate?getUtcDateWithLocalMidnight(viewDate): null}
        hourFormat="24"
      />
    </div>
  );
};

export default SingleCalendar;